import { FiGithub, FiLinkedin } from "react-icons/fi";
import {
  BurgerSocialsWrapper,
  EmailText,
  //   IconNames,
  IconTextWrapper,
  IconsWrapper,
  LeftSocialBar,
  RightSocialBar,
  VerticalLineLeft,
  VerticalLineRight,
} from "./BurgerSocials.styled";

export const BurgerSocials = () => {
  return (
    <BurgerSocialsWrapper>
      <LeftSocialBar className="LeftBurgerSocialBar">
        <IconsWrapper>
          <a href="https://github.com/VasilHT">
            <IconTextWrapper>
              <FiGithub style={{ height: "20px", width: "20px" }} />
              {/* <IconNames>Github</IconNames> */}
            </IconTextWrapper>
          </a>
          <a href="https://www.linkedin.com/in/vasilht/">
            <IconTextWrapper>
              <FiLinkedin style={{ height: "20px", width: "20px" }} />
              {/* <IconNames>Linkedin</IconNames> */}
            </IconTextWrapper>
          </a>
        </IconsWrapper>
        <VerticalLineLeft />
      </LeftSocialBar>
      <RightSocialBar className="RightBurgerSocialBar">
        <EmailText>vasil.htosev@gmail.com</EmailText>
        <VerticalLineRight />
      </RightSocialBar>
    </BurgerSocialsWrapper>
  );
};
